/**
 * Which puller wrote a `reporting_runs` row. PURE, a LEAF.
 *
 * ⚠️⚠️ `reporting_runs` IS SHARED SINCE 2026-09-27: the GA4 pull writes its runs
 * there too, so Sync Health shows them. But every freshness figure derived from
 * that table — the Meta "as at" stamp on the staff dashboards, the job-liveness
 * verdict, the died-run count — is a statement about the META pull. A GA4 run that
 * finished cleanly at 09:00 must not make the Meta figures read "as at 09:00".
 * `resolveDataFreshness` excludes these modes; anything else that reads the table
 * for Meta freshness must do the same.
 */
export const GA4_RUN_MODES = ['ga4-refresh', 'ga4-backfill'] as const;
export type Ga4RunMode = (typeof GA4_RUN_MODES)[number];

export function isGa4RunMode(mode: string | null | undefined): boolean {
  return mode != null && (GA4_RUN_MODES as readonly string[]).includes(mode);
}
